import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import 'moment/locale/pl';
import 'react-dates/lib/css/_datepicker.css';

import { filterP24Logs } from "../../actions/p24LogActions";
import { FILTER_DATE_FORMAT } from "../../constants/dates"

/**
 * Filtr do transakcji p24. Zawiera 
 * 
 * - zakres dat - domyślnie ostatni miesiąc
 * 
 * Wybrany filtr jest zapisywany do reducera.
 * Daty są wymagane, jeśli filtr nie przechodzi walidacji - mamy czerwoną ramke.
 * 
 * https://ourcodeworld.com/articles/read/535/top-10-best-open-source-reactjs-datepicker-components
 * 
 * https://github.com/airbnb/react-dates 
 *
 * https://airbnb.io/react-dates/?path=/story/daterangepicker-drp--default
 *
 */
class P24LogFilter extends React.Component {

    state = {
        startDate: this.props.p24LogFilter.startDate,
        endDate: this.props.p24LogFilter.endDate,
        isValid: true
    };

    componentDidMount() {
        //ustawiamy lokal polski
        moment.locale('pl'); // Polish
    }

    /**
     * Metoda walidująca czy obie daty z zakresu są wypełnione
     * 
     * @returns true - jeśli tak, false - jeśli nie
     */
    isValid = (startDate, endDate) => {
        if (startDate == null || endDate == null) {
            return false;
        }
        return true;
    }

    render() {
        return (
            <div className="w3-center">
                <div>

                    <div className={this.state.isValid ? '' : 'required'}>
                        Zakres dat: &nbsp;
                        <DateRangePicker
                            startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                            startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                            endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                            endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                            onDatesChange={async ({ startDate, endDate }) => {

                                const isValid = this.isValid(startDate, endDate);
                                this.setState({ startDate, endDate, isValid: isValid })
                                if (isValid) {
                                    //ustawiamy dane w reducerze, tylko jesli sa poprawne
                                    //wywołujemy asynchonicznie, aby metoda onFilterChange miała aktualne dane z reducera (bez tego ma poprzednie dane)
                                    await this.props.filterP24Logs({ startDate, endDate });
                                    this.props.onFilterChange();
                                }

                            }
                            } // PropTypes.func.isRequired,
                            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                            onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,

                            required={true} // daty sa wymagane - nie działa

                            startDatePlaceholderText='Data od' //PropTypes.string,
                            endDatePlaceholderText='Data do' //PropTypes.string,

                            //aby mozna bylo ustawic przeszlosc
                            isOutsideRange={() => false}

                            //X na czyszczenie dat
                            showClearDates={true} //PropTypes.bool,

                            //zmieniamy format z DD.MM.YYYY na YYYY-MM-DD
                            displayFormat={() => FILTER_DATE_FORMAT} //PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

                            //pomniejszamy widok i w css zwiekszamy input, bo data się nie mieści
                            small={true} //PropTypes.bool,

                            //mozemy wybrac ta sama date w obu inputach
                            minimumNights={0}
                        />

                    </div>

                </div>
            </div>
        )
    }
}

P24LogFilter.propTypes = {
    //akcja zwrotna na zmianę filtra
    onFilterChange: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    p24LogFilter: state.p24LogReducer.p24LogFilter,
});

const mapDispatchToProps = ({
    filterP24Logs: filterP24Logs
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P24LogFilter);